import React from 'react'
import { Modal } from 'components'
import img_1 from 'assets/img/Renewal/1.jpg'
import img_2 from 'assets/img/Renewal/2.jpg'
import img_3 from 'assets/img/Renewal/3.jpg'
import img_4 from 'assets/img/Renewal/4.jpg'


const angleRight = <i className='fas fa-angle-right'></i>;
const uanalyzeLineHref = 'https://lin.ee/FKhgcV6';
const uanalyzeLineLink = (
    <a href={uanalyzeLineHref} target='_blank' rel='noopener noreferrer'>
        {uanalyzeLineHref}
    </a>
);
const scrollToSection = (id) => (e) => {
    const section = document.getElementById(id);

    if (section) { section.scrollIntoView(); }
};
const RenewalModal = ({ className }) => {
    const contentsMap = (item, key) => (
        <li onClick={scrollToSection(item.id)} key={key}>{angleRight} {item.text}</li>
    );
    const contents = [
        { id: `Q1-${className}`, text: '如何查詢有效期限、及自動續約狀態？' },
        { id: `Q2-${className}`, text: '如何查詢付款訂單？' },
        { id: `Q3-${className}`, text: '如何續約？' },
        { id: `Q4-${className}`, text: '如何變更付款方式？' },
        { id: `Q5-${className}`, text: '如何變更信用卡？' },
        { id: `Q6-${className}`, text: '信用卡自動續約失敗如何處理？' },
    ]

    return (
        <Modal
            id={`renewal-instructions${className ? '-' + className : ''}`}
            title='續約說明'
            html={
                <div className='lab-btn-modal-wrap'>
                    <div className='lab-btn-modal-contents'>
                        <ul>
                            {contents.map(contentsMap)}
                        </ul>
                    </div>

                    <section id={contents[0].id}>
                        <h2>Q：{contents[0].text}</h2>

                        <ol>
                            <li>點擊左上角『選單』(三條線)</li>

                            <li>點擊『我的帳戶』</li>

                            <img src={img_1} alt={contents[0].text}/>

                            <li>點擊『已購模組』</li>

                            <li>點擊篩選『策略包』</li>

                            <li>點擊你欲查看的『訂閱產品名稱』</li>

                            <li>狀態為『單次訂閱』代表
                                <span className='text-highlight'>不會</span>
                                自動續約；狀態為『訂閱中』將
                                <span className='text-highlight'>會</span>
                                自動續約
                            </li>

                            <img src={img_2} alt={contents[0].text}/>
                        </ol>
                    </section>

                    <section id={contents[1].id}>
                        <h2>Q：{contents[1].text}</h2>

                        <ol>
                            <li>點擊左上角『選單』（三條線）</li>

                            <li>點擊『我的帳戶』</li>
                            
                            <img src={img_1} alt={contents[1].text}/>

                            <li>點擊『訂單查詢』</li>

                            <li>點擊你欲察看的日期</li>

                            <img src={img_3} alt={contents[1].text}/>

                            <li>點擊『訂單詳情』</li>

                            <img src={img_4} alt={contents[1].text}/>
                        </ol>
                    </section>

                    <section id={contents[2].id}>
                        <h2>Q：{contents[2].text}</h2>

                        <p>
                            <strong>狀況一：</strong>
                            當初以信用卡付款，將會
                            <span className='text-highlight'>自動</span>
                            續約，無需做任何操作。
                        </p>

                        <p>
                            <strong>狀況二：</strong>
                            當初以ATM轉帳、超商付款，則需手動續約，請參考下方操作。
                        </p>

                        <h3>手動續約方式：</h3>

                        <ol>
                            <li>手動續約要在有效期限過了才能執行，
                                <span className='text-highlight'>無法提前</span>
                                。
                            </li>

                            <li>待有效期限過後，洽優分析 LINE 官方客服：</li>

                            {uanalyzeLineLink}

                            <li>領取『續約碼』</li>

                            <li>回優分析結帳付款，並在結帳時輸入『續約碼』</li>
                        </ol>
                    </section>

                    <section id={contents[3].id}>
                        <h2>Q：{contents[3].text}</h2>

                        <p>洽優分析 LINE 官方客服：</p>
                        
                        {uanalyzeLineLink}
                    </section>

                    <section id={contents[4].id}>
                        <h2>Q：{contents[4].text}</h2>

                        <p>信用卡換卡等問題，請洽優分析 LINE 官方客服：</p>
                        
                        {uanalyzeLineLink}
                    </section>

                    <section id={contents[5].id}>
                        <h2>Q：{contents[5].text}</h2>

                        <p>
                            自動續約失敗、或信用卡過期、換卡、額度已滿等問題，請洽優分析 LINE 官方客服：
                        </p>

                        {uanalyzeLineLink}
                    </section>
                </div>
            }
            leaveTxt = '我知道了'
        />
    );
};


export { RenewalModal }
